<template>
  <div id="pageCadastroPraca">
    <v-container grid-list-x2 fluid>
      <v-layout row wrap justify-center>
        <v-flex lg8 sm12 xs12>
          <v-card>
            <v-toolbar color="pink" dark flat dense cad>
              <v-toolbar-title class="subheading">Visualizar praça</v-toolbar-title>
              <v-spacer></v-spacer>
              <router-link :to="{ name: 'Praca' }" class="nounderline">
                <v-btn outline>Voltar</v-btn>
              </router-link>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="">
              <praca-form></praca-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import PracaForm from "@/components/praca/formViewPraca"
export default {
  components: {
    PracaForm
  },
  data: () => ({
    id: null
  }),
  created() {
    if (this.$route && this.$route.params) {
      this.id = this.$route.params.id
    }
  }
}
</script>
